var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmenidadesWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.937,
    height: 40.501,
    viewBox: "0 0 43.937 40.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Amenidades_white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M85.608,262.436a.859.859,0,1,0-.607-.252A.859.859,0,0,0,85.608,262.436Z",
    transform: "translate(-77.885 -239.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M35.428,22.577a5.922,5.922,0,1,0,3.477-11.183A9.482,9.482,0,1,0,20.131,9.5c0,.306.015.614.045.919A7.6,7.6,0,0,0,15.5,21.14h-4.34a.859.859,0,0,0,0,1.716h9.954v3.776H1.716V22.857H4.293a.859.859,0,0,0,0-1.716H.858A.858.858,0,0,0,0,22V27.49a.858.858,0,0,0,.858.858H3.432v3.078H.858A.858.858,0,0,0,0,32.285v3.432a.858.858,0,0,0,.858.858H3.432v2.231H.858a.859.859,0,0,0,0,1.716H38.444a.859.859,0,0,0,0-1.716h-.088c.006-.092.009-.184.009-.276a4.911,4.911,0,0,0-7.894-3.905V26.189A6.48,6.48,0,0,0,35.428,22.577ZM17.5,21.14a5.875,5.875,0,0,1,3.781-9.213.857.857,0,0,0,.7-1,7.765,7.765,0,1,1,15.016,1,.858.858,0,0,0,.85,1.124c.056,0,.113,0,.171,0A4.2,4.2,0,1,1,35.5,20.626a.858.858,0,0,0-1.338.455,4.742,4.742,0,0,1-3.694,3.373V18.791l4.259-4.259a.859.859,0,1,0-1.215-1.215l-3.046,3.046V12.928a.859.859,0,0,0-1.716,0v5.508h0v1.011l-3.321-3.325a.859.859,0,0,0-1.215,1.215L28.7,21.823c.017.017.035.032.053.048v2.584a4.68,4.68,0,0,1-2.6-1.43.857.857,0,0,0-1.043-.162,5.878,5.878,0,0,1-2.285.7V22a.859.859,0,0,0-.859-.858Zm4.47,7.209a.858.858,0,0,0,.858-.858v-2.2a7.625,7.625,0,0,0,2.541-.643,6.474,6.474,0,0,0,3.388,1.539v9.04A4.475,4.475,0,0,0,24.889,38.8h-5.5V36.575h2.574a.858.858,0,0,0,.858-.858V32.285a.858.858,0,0,0-.858-.859H19.393V28.348Zm-16.819,0H17.677v3.078H5.149ZM1.716,33.143H21.109v1.716H1.716Zm3.432,3.432H17.677v2.231H5.149Zm25.7.092a3.2,3.2,0,0,1,5.8,1.863c0,.092,0,.185-.012.276H26.659A2.754,2.754,0,0,1,29.944,37,.857.857,0,0,0,30.849,36.666Z",
    transform: "translate(0 -0.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M355.83,108.143a.857.857,0,1,0-.607-.251A.857.857,0,0,0,355.83,108.143Z",
    transform: "translate(-326.218 -97.809)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenidadesWhite);
export default __webpack_public_path__ + "static/media/Amenidades_white.3150be66277086b9aa4cf9ecad4e2329.svg";
export { ForwardRef as ReactComponent };